import { cva } from '@/styled-system/css';

export const tagLabelRecipe = cva({
  base: {
    color: 'inherit!',
  },
  variants: {
    size: {
      sm: {
        textStyle: 'body-xs-bold',
      },
      md: {
        textStyle: 'body-sm-bold',
      },
    },
  },
});
